import { gql } from "@apollo/client";
import { ProductFieldsFragment } from "@govlaunch/product";
import { ProjectCardFieldsFragment } from "@govlaunch/project";
import { RelatedStoriesFieldsFragment } from "@govlaunch/story";

export default gql`
  query ProductBySlug($slug: String!, $language: String) {
    product(slug: $slug, language: $language) {
      ...ProductFields
      company {
        viewerIsMember
      }
      stories {
        ...RelatedStoriesFields
      }
      projects {
        ...ProjectCardFields
      }
    }
  }

  ${ProductFieldsFragment}
  ${RelatedStoriesFieldsFragment}
  ${ProjectCardFieldsFragment}
`;
